import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const RoleBasedRedirect = () => {
  const { user, isLoading } = useAuth();

  // Show loading while fetching user details
  if (isLoading) {
    return <div>Loading...</div>;
  }

  // If no user, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check user roles and redirect accordingly
  const roles = user.roles || [];

  // Admin users go to admin overview
  if (roles.includes("Admin")) {
    return <Navigate to="/dashboard/admin_overview" replace />;
  }

  // City Admin users go to city admin overview
  if (roles.includes("City Admin")) {
    return <Navigate to="/dashboard/overview" replace />;
  }

  // Default fallback to overview
  return <Navigate to="/dashboard/overview" replace />;
};

export default RoleBasedRedirect;

